var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeasonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M447 47h-26V31c0-16.542-13.458-30-30-30h-30c-16.542 0-30 13.458-30 30v16H181V31c0-16.542-13.458-30-30-30h-30c-16.542 0-30 13.458-30 30v16H65C29.159 47 0 76.159 0 112v334c0 35.841 29.159 65 65 65h382c35.841 0 65-29.159 65-65V112c0-35.841-29.159-65-65-65zm-86-16h30v60h-30l-.019-59.999L361 31zm-240 0h30v60h-30l-.019-59.999L121 31zM65 77h26v14c0 16.542 13.458 30 30 30h30c16.542 0 30-13.458 30-30V77h150v14c0 16.542 13.458 30 30 30h30c16.542 0 30-13.458 30-30V77h26c19.299 0 35 15.701 35 35v39H30v-39c0-19.299 15.701-35 35-35zm382 404H65c-19.299 0-35-15.701-35-35V181h452v265c0 19.299-15.701 35-35 35z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.942 277.917c4.527-22.893-5.652-47.168-26.96-59.47-21.601-12.471-47.679-8.827-64.982 6.355-17.267-15.15-43.336-18.853-64.982-6.355-21.308 12.302-31.487 36.576-26.959 59.47-22.09 7.526-38.023 28.479-38.023 53.083s15.933 45.557 38.022 53.083c-4.527 22.893 5.652 47.168 26.96 59.47 21.298 12.297 47.404 9.068 64.982-6.355 17.276 15.157 43.348 18.845 64.982 6.355 21.308-12.302 31.487-36.576 26.959-59.47 22.09-7.526 38.023-28.479 38.023-53.083s-15.933-45.557-38.022-53.083zm-18.036 79.142h-2.79c-11.503 0-18.774 12.483-12.99 22.5l1.395 2.416c7.184 12.444 2.905 28.413-9.539 35.597-12.472 7.2-28.394 2.936-35.597-9.539-.538-.591-4.026-9.916-14.385-9.916-10.416 0-13.828 9.304-14.385 9.916-7.202 12.473-23.122 16.739-35.597 9.539-12.444-7.185-16.723-23.153-9.539-35.597l1.395-2.416c5.752-9.961-1.423-22.5-12.99-22.5h-2.79c-14.369 0-26.059-11.69-26.059-26.059s11.69-26.059 26.059-26.059h2.79c11.503 0 18.774-12.483 12.99-22.5l-1.395-2.416c-7.184-12.444-2.905-28.413 9.539-35.597 12.473-7.202 28.395-2.935 35.597 9.539.538.591 4.026 9.916 14.385 9.916 10.416 0 13.828-9.304 14.385-9.916 7.202-12.472 23.122-16.741 35.597-9.539 12.444 7.185 16.723 23.153 9.539 35.597-.242.759-6.575 8.444-1.396 17.416 5.208 9.02 14.964 7.322 15.781 7.5 14.369 0 26.059 11.69 26.059 26.059s-11.691 26.059-26.059 26.059z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 286c-24.813 0-45 20.187-45 45s20.187 45 45 45 45-20.187 45-45-20.187-45-45-45zm0 60c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonIcon);
export default __webpack_public_path__ + "static/media/season-icon.73a98a53edd8ef3ec56383e3e418a0a3.svg";
export { ForwardRef as ReactComponent };